import type { Student } from "../../../../lib/students-data"
import { StudentTableRow } from "./student-table-row"
import { PaginationStats } from "../students-management/pagination-stats"

interface StudentTableProps {
  students: Student[]
  onEdit: (student: Student) => void
  onDelete: (id: string) => void
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

export function StudentTable({ students, onEdit, onDelete, currentPage, totalPages, onPageChange }: StudentTableProps) {
  const resultsPerPage = 10
  const totalResults = students.length * totalPages

  return (
    <div className="bg-card rounded-xl shadow-lg border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-muted border-b border-border">
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Student Name</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Class</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Grades (GPA)</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Career Path</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Guardian Info</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase text-right">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {students.map((student) => (
              <StudentTableRow key={student.id} student={student} onEdit={onEdit} onDelete={onDelete} />
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-5 py-4 border-t border-border">
        <PaginationStats
          currentPage={currentPage}
          totalPages={totalPages}
          totalResults={totalResults}
          resultsPerPage={resultsPerPage}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  )
}
